import { DndContext } from "@dnd-kit/core";
import { restrictToHorizontalAxis } from "@dnd-kit/modifiers";
import { useCallback } from "react";

import type { CustomDnDResult } from "@/hooks/use-dnd/use-custom-dnd";

import { Dialog, DialogClose, DialogContent } from "@/components/ui/dialog/dialog";

import { SNSColorSelectSection } from "./dialog/sns-color";
import { SNSIconsSection } from "./dialog/sns-icons";
import { SelectedSNSIcons } from "./selected-sns-icons";

import type { SnackBlocksFormModelMethodsType } from "../../../../../model/usecase/use-create-snack-layout-settings-form-model/methods";
import type { DragEndEvent } from "@dnd-kit/core";

type Props = {
	SNSMethods: SnackBlocksFormModelMethodsType["SNSMethods"];
};

export type SnackSNSIconsCustomDnDResult = CustomDnDResult<
	SnackBlocksFormModelMethodsType["SNSMethods"]["snsIcons"]["value"][number]
>;

export const IslandLayoutSettingsSNS = ({ SNSMethods }: Props) => {
	const {
		activateModal,
		onOpenChange,
		deactivateModal,
		isShowModal,
		snsColor,
		snsIcons,
		onSetSnackSnsColorToSNSColor,
		onSetIsSelectedToSNSIcons,
		onSetSNSURLToSnsIcons,
		onSetSNSIcons,
	} = SNSMethods;

	const handleDragEnd = useCallback(
		(event: DragEndEvent) => {
			const { active, over } = event;
			if (active && over) {
				const activeIndex = snsIcons.value.findIndex((item) => item.snsType.value === active.id);
				const overIndex = snsIcons.value.findIndex((item) => item.snsType.value === over.id);
				const newSnsIcons = [...snsIcons.value];
				const [removed] = newSnsIcons.splice(activeIndex, 1);
				newSnsIcons.splice(overIndex, 0, removed);

				onSetSNSIcons({ isEdited: true, hasError: true, value: newSnsIcons });
			}
		},
		[onSetSNSIcons, snsIcons.value],
	);

	return (
		<DndContext modifiers={[restrictToHorizontalAxis]} onDragEnd={handleDragEnd}>
			<div className="flex justify-center">
				<SelectedSNSIcons snsIcons={snsIcons} activateModal={activateModal} snsColor={snsColor} />

				<Dialog open={isShowModal} onOpenChange={onOpenChange}>
					<DialogClose onClick={deactivateModal} />

					<DialogContent>
						<div className="space-y-6">
							<SNSColorSelectSection
								snsColor={snsColor}
								onSetSnackSnsColorToSNSColor={onSetSnackSnsColorToSNSColor}
							/>

							<SNSIconsSection
								snsIcons={snsIcons}
								onSetIsSelectedToSNSIcons={onSetIsSelectedToSNSIcons}
								onSetSNSURLToSnsIcons={onSetSNSURLToSnsIcons}
							/>
						</div>
					</DialogContent>
				</Dialog>
			</div>
		</DndContext>
	);
};

IslandLayoutSettingsSNS.displayName = "IslandLayoutSettingsSNS";
